import React from "react";
import "./contact.css";

function Contac() {
    return (
        <div className="a1">

            <div className="layout">
                <div className="contacts">
                    <h1>Vicar</h1>
                    <img src="./images/Fr_James.jpg" alt="Fr. James Athiyunthan" />
                    <h2>Rev. Fr. James Athiyunthan</h2>
                    <h3>
                        <a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>
                            ☎️ +91 XXXXXXXXXX
                        </a>
                    </h3>
                </div>
            </div>

            <div className="layout">
                <div className="contacts">
                    <h1>Trustee</h1>
                    <img src="./images/dummy.png" alt="Trustee 1" />
                    <h2>Name 1</h2>
                    <h3>
                        <a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>
                            ☎️ +91 XXXXXXXXXX
                        </a>
                    </h3>
                </div>

                <div className="contacts">
                    <h1>Trustee</h1>
                    <img src="./images/dummy.png" alt="Trustee 2" />
                    <h2>Name 2</h2>
                    <h3>
                        <a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>
                            ☎️ +91 XXXXXXXXXX
                        </a>
                    </h3>
                </div>

                <div className="contacts">
                    <h1>Trustee</h1>
                    <img src="./images/dummy.png" alt="Trustee 3" />
                    <h2>Name 3</h2>
                    <h3>
                        <a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>
                            ☎️ +91 XXXXXXXXXX
                        </a>
                    </h3>
                </div>
            </div>

            <div className="layout">
                <div className="contacts">
                    <h1>Kaypar</h1>
                    <img src="./images/dummy.png" alt="Kaypar" />
                    <h2>Kaypar</h2>
                    <h3>
                        <a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>
                            ☎️ +91 XXXXXXXXXX
                        </a>
                    </h3>
                </div>

                <div className="contacts">
                    <h1>Accountant</h1>
                    <img src="./images/dummy.png" alt="Accountant" />
                    <h2>Accountant</h2>
                    <h3>
                        <a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>
                            ☎️ +91 XXXXXXXXXX
                        </a>
                    </h3>
                </div>
            </div>

            <div className="layout">
                <div className="contact-office">

                    <div className="spliting-left">
                        <h1>Parish Office</h1>
                        <h3>
                            <a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px", color: "red" }}>
                                ☎️ +91 XXXXXXXXXX
                            </a>
                        </h3>
                        <h3>
                            <a href="mailto:stantonyschurchvasupuram1981@gmail.com" style={{ textDecoration: "none", fontSize: "18px" }}>
                                ✉️ stantonyschurchvasupuram1981@gmail.com
                            </a>
                        </h3>

                        <h1>Parish Hall</h1>
                        <h3>
                            <a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px", color: "red" }}>
                                ☎️ +91 XXXXXXXXXX
                            </a>
                        </h3>
                    </div>

                    <div className="spliting-right">
                        <img src="./images/parish_hall.jpg" alt="Parish Hall" />
                    </div>

                </div>
            </div>

        </div>
    );
}

export default Contac;